// extracted by mini-css-extract-plugin
export var Wrapper = "Info-module--Wrapper--JCfON";
export var LangHY = "Info-module--LangHY--59zwT";
export var Address = "Info-module--Address--wU3cg";
export var SubTitle = "Info-module--SubTitle--hSnGQ";
export var SocialLinks = "Info-module--SocialLinks--a7kNN";
export var Title = "Info-module--Title--i7cXd";
export var Office = "Info-module--Office--eODf6";
export var Department = "Info-module--Department--rqLLD";
export var Social = "Info-module--Social--Y8cUM";
export var Separator = "Info-module--Separator--v+07g";
export var arrowLeft = "Info-module--arrowLeft--tFssL";
export var arrowRight = "Info-module--arrowRight--SeYg1";